import { Instagram, Palette, TrendingUp, Video, Target, Users, Camera, PenTool, MapPin } from 'lucide-react';

const mockData = {
  services: [
    {
      title: 'Gestão de Redes Sociais',
      description: 'Planejamento, criação e publicação de conteúdo estratégico para engajar sua audiência e construir autoridade.',
      icon: <Instagram className="w-8 h-8 text-slate-blue" />
    },
    {
      title: 'Branding e Identidade Visual',
      description: 'Desenvolvimento de identidade visual completa que transmite os valores da sua marca de forma única e memorável.',
      icon: <Palette className="w-8 h-8 text-chartreuse" />
    },
    {
      title: 'Tráfego Pago',
      description: 'Campanhas otimizadas de anúncios no Google, Meta e outras plataformas para gerar leads qualificados.',
      icon: <TrendingUp className="w-8 h-8 text-giants-orange" />
    },
    {
      title: 'Criação de Conteúdo',
      description: 'Produção profissional de fotos, vídeos e reels que contam a história da sua marca de forma autêntica.',
      icon: <Video className="w-8 h-8 text-slate-blue" />
    },
    {
      title: 'Cobertura de Eventos',
      description: 'Registro profissional e estratégico de todos os momentos importantes do seu evento, transformando a experiência ao vivo em conteúdos de alto impacto para redes sociais.',
      icon: <Camera className="w-8 h-8 text-giants-orange" />
    },
    {
      title: 'Pacote de Artes',
      description: 'Criação de peças visuais profissionais e estratégicas para fortalecer a identidade da sua marca nas redes sociais.',
      icon: <PenTool className="w-8 h-8 text-chartreuse" />
    },
    {
      title: 'Projeto Multiplicadores',
      description: 'Estratégia exclusiva para transformar clientes em promotores da sua marca, gerando crescimento orgânico.',
      icon: <Users className="w-8 h-8 text-slate-blue" />
    },
    {
      title: 'Estratégia e Consultoria',
      description: 'Planejamento estratégico personalizado com análise de mercado, concorrência e oportunidades de crescimento.',
      icon: <Target className="w-8 h-8 text-giants-orange" />
    },
    {
      title: 'Visita Técnica',
      description: 'Análise presencial do seu negócio para identificar oportunidades estratégicas e realizar um diagnóstico completo, alinhando ações de marketing com foco em resultados.',
      icon: <MapPin className="w-8 h-8 text-slate-blue" />
    }
  ],

  plans: [
    {
      name: 'Orion',
      emoji: '🪐',
      badge: null,
      badgeColor: null,
      description: 'Ideal para empresas que desejam construir uma presença digital consistente.',
      gradient: 'from-raisin-black to-slate-blue/10',
      borderColor: 'border-slate-blue/40',
      glowColor: 'slate-blue',
      cta: 'Começar Agora',
      features: [
        { icon: 'Grid', text: '12 conteúdos mensais', sub: 'Postagens ou Reels estratégicos' },
        { icon: 'MessageCircle', text: 'Estratégia de Stories', sub: 'Guia exclusivo para manter o perfil ativo diariamente' },
        { icon: 'Target', text: 'Tráfego Pago Essencial', sub: '1 campanha ativa (Topo de Funil) · 1 otimização mensal' },
        { icon: 'Camera', text: 'Captação de Conteúdo', sub: 'Até 2 visitas mensais · Produção e edição de vídeos curtos' },
        { icon: 'Calendar', text: '1 reunião de alinhamento por mês' },
        { icon: 'BarChart3', text: 'Relatório de desempenho', sub: 'Sob solicitação' },
      ]
    },
    {
      name: 'Sirius',
      emoji: '⭐',
      badge: 'MAIS CONTRATADO',
      badgeColor: 'chartreuse',
      description: 'Para empresas que querem acelerar o crescimento e gerar oportunidades de venda.',
      gradient: 'from-raisin-black to-chartreuse/10',
      borderColor: 'border-chartreuse/60',
      glowColor: 'chartreuse',
      cta: 'Quero Crescer',
      features: [
        { icon: 'Grid', text: '20 conteúdos mensais', sub: 'Postagens ou Reels estratégicos' },
        { icon: 'MessageCircle', text: 'Estratégia de Stories', sub: 'Guia exclusivo · Publicação pela equipe Milyan quando necessário' },
        { icon: 'Target', text: 'Tráfego Pago Otimizado', sub: 'Até 2 campanhas simultâneas · Topo e Meio de Funil · Otimizações semanais' },
        { icon: 'Camera', text: 'Captação de Conteúdo', sub: 'Até 4 visitas mensais · Produção e edição de vídeos curtos' },
        { icon: 'Calendar', text: '2 reuniões de alinhamento por mês' },
        { icon: 'BarChart3', text: 'Relatório de desempenho', sub: 'Sob solicitação' },
      ]
    },
    {
      name: 'Milyan',
      emoji: '🚀',
      badge: 'EXPERIÊNCIA PREMIUM',
      badgeColor: 'slate-blue',
      description: 'Uma equipe de marketing dedicada ao crescimento da sua empresa.',
      gradient: 'from-raisin-black to-giants-orange/10',
      borderColor: 'border-giants-orange/40',
      glowColor: 'giants-orange',
      cta: 'Quero uma Equipe Estratégica',
      features: [
        { icon: 'Grid', text: '28 conteúdos mensais', sub: 'Postagens, Reels e conteúdos estratégicos' },
        { icon: 'MessageCircle', text: 'Gestão Estratégica de Stories', sub: 'Planejamento semanal · Publicação pela equipe Milyan · Estratégia contínua' },
        { icon: 'Target', text: 'Tráfego Pago Avançado', sub: 'Até 6 campanhas simultâneas · Ajustes frequentes conforme performance' },
        { icon: 'Users', text: 'Projeto Multiplicadores', sub: 'Treinamento da equipe para produzir conteúdo estratégico' },
        { icon: 'Sparkles', text: 'Time dedicado à sua empresa' },
        { icon: 'Camera', text: 'Captação de Conteúdo', sub: 'Até 8 visitas mensais · Produção e edição de vídeos curtos' },
        { icon: 'Clipboard', text: 'Consultoria Estratégica' },
        { icon: 'Calendar', text: '1 reunião semanal de alinhamento' },
        { icon: 'Zap', text: 'Atendimento prioritário' },
        { icon: 'BarChart3', text: 'Relatório de desempenho', sub: 'Sob solicitação' },
      ]
    }
  ],

  eventPlans: [
    {
      name: 'Orion',
      gradient: 'from-raisin-black to-slate-blue/10',
      borderColor: 'border-slate-blue/40',
      popular: false,
      features: [
        'Até 4h de Cobertura',
        'Captação com equipamento profissional',
        '2 Reels editados',
        'Entrega em 3 dias úteis',
        'Direcionamento básico de captação'
      ]
    },
    {
      name: 'Sirius',
      gradient: 'from-raisin-black to-chartreuse/10',
      borderColor: 'border-chartreuse/60',
      popular: true,
      features: [
        'Até 8h de Cobertura',
        'Captação completa (bastidores + momentos-chave)',
        '4 Reels editados',
        'Captação de depoimentos estratégicos',
        'Entrega rápida (teaser em até 24h)',
        'Direcionamento criativo durante o evento'
      ]
    },
    {
      name: 'Milyan',
      gradient: 'from-raisin-black to-giants-orange/10',
      borderColor: 'border-giants-orange/40',
      popular: false,
      features: [
        'Até 12h de Cobertura',
        'Captação cinematográfica + bastidores + detalhes',
        '6 Reels editados',
        '1 vídeo institucional do evento',
        'Captação estruturada de depoimentos',
        'Entrega expressa (primeiro vídeo em até 24h)',
        'Direção criativa completa'
      ]
    }
  ],

  packages: [
    { name: 'Pack de Artes', price: 'R$ 249,90' },
    { name: 'Pack de Vídeos', price: 'R$ 499,90' },
    { name: 'Estratégia e Consultoria', price: 'R$ 499,90' },
    { name: 'Gestão de Tráfego', price: 'R$ 349,90' }
  ],

  clients: [
    {
      name: 'Araken Pet Center',
      logo: 'https://customer-assets.emergentagent.com/job_milyan-strategy/artifacts/ajo4cahd_araken%20%281%29.png'
    },
    {
      name: 'Hospital de Olhos Niterói',
      logo: 'https://customer-assets.emergentagent.com/job_milyan-strategy/artifacts/kaum6tjq_logo%20hon%20%281%29.png'
    },
    {
      name: 'Espaço Harmonia',
      logo: 'https://customer-assets.emergentagent.com/job_milyan-strategy/artifacts/2ezf0xa0_espa%C3%A7o%20%281%29.png'
    },
    {
      name: 'Cervejaria Maltz',
      logo: 'https://customer-assets.emergentagent.com/job_milyan-strategy/artifacts/ki8mhr4i_marlx%20%281%29.png'
    },
    {
      name: 'Predtek Energia & Automação',
      logo: 'https://customer-assets.emergentagent.com/job_848286f8-5d7d-4e07-b946-7ff0281af2a5/artifacts/53lxwmga_LOGO%20VET%20PREDTEK.png'
    },
    {
      name: 'Planeta Animal Pet Shop',
      logo: 'https://customer-assets.emergentagent.com/job_848286f8-5d7d-4e07-b946-7ff0281af2a5/artifacts/f5vlxr2u_LOGO%20PLANETA%20ANIMAL.png'
    },
    {
      name: 'Veterinária Maricá',
      logo: 'https://customer-assets.emergentagent.com/job_848286f8-5d7d-4e07-b946-7ff0281af2a5/artifacts/y2ao3rq7_LOGO%20VET%20MARICA.png'
    },
    {
      name: 'Royal Pet Shop',
      logo: 'https://customer-assets.emergentagent.com/job_848286f8-5d7d-4e07-b946-7ff0281af2a5/artifacts/dgridoy4_LOGO%20ROYAL.png'
    },
    {
      name: 'Sam Figueiredo Cerimonial',
      logo: 'https://customer-assets.emergentagent.com/job_848286f8-5d7d-4e07-b946-7ff0281af2a5/artifacts/vloo4q00_LOGO%20VET%20SAM%20FIGUEIREDO.png'
    },
    {
      name: 'Mega Hair Jô Rigon',
      logo: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_848286f8-5d7d-4e07-b946-7ff0281af2a5/artifacts/wgv203xp_MEGA%20HAIR.png'
    },
    {
      name: 'Maison Chic',
      logo: 'https://customer-assets-lxgj4vgw.emergentagent.net/job_848286f8-5d7d-4e07-b946-7ff0281af2a5/artifacts/83fexska_MAISON%20CHIC.png'
    }
  ],

  testimonials: [
    {
      quote: 'Equipe muito profissional. Trabalhamos juntos há mais de 2 anos!',
      name: 'Araken Figueira',
      company: 'Araken Pet Center',
      photo: 'https://customer-assets.emergentagent.com/job_848286f8-5d7d-4e07-b946-7ff0281af2a5/artifacts/xhnnxmk5_ARAKEN%20%282%29.png'
    },
    {
      quote: 'O Yann fez um excelente trabalho conosco!',
      name: 'Faiga Marques',
      company: 'Hospital de Olhos Niterói',
      photo: 'https://customer-assets.emergentagent.com/job_848286f8-5d7d-4e07-b946-7ff0281af2a5/artifacts/p6v9pdj9_FAIGA.png'
    },
    {
      quote: 'Equipe paciente e atenciosa. Me ajudam muito, principalmente nas gravações!',
      name: 'Rebeca Oliveira',
      company: 'Espaço Harmonia',
      photo: 'https://customer-assets.emergentagent.com/job_848286f8-5d7d-4e07-b946-7ff0281af2a5/artifacts/7xyeates_REBECA.png'
    },
    {
      quote: 'Profissionais incríveis, atenciosos e extremamente competentes. Fazem um trabalho espetacular!',
      name: 'Samara Figueiredo',
      company: 'Sam Doces e Eventos',
      photo: 'https://customer-assets.emergentagent.com/job_848286f8-5d7d-4e07-b946-7ff0281af2a5/artifacts/3q1snvxx_IMG_8449.jpg'
    }
  ],

  videos: [
    { url: 'https://www.instagram.com/reel/DVeuEh3gMyM/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/C95nh9tRvoz/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DWXHJhwhS2n/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DDrinYvqrzX/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DT-7ogMAN9d/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/C8C4_ZYuTf-/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DUEds6yACgR/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/ClHTje-joEF/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DWC6qe6DqJe/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/C-YhRYsiBdJ/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DUwQBM1gHtv/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DBTvkPax1QZ/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DWShwRtDlSJ/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/C_l4wqkx4Ew/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DP13gOlkT2E/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DCtqndePA-J/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DU6jGzTks-W/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/C-5-cQavn4x/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DCW2y5OOuTS/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DDuOR_chZrB/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DPluHGNkYRB/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/C8-ZdvBR-8Y/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/C_5w1lZOoSF/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DCSL98Ui7B9/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DV14nPukaV_/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DWIFfTjEc5I/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DW9ulflkbIt/', type: 'reel' },
    { url: 'https://www.instagram.com/p/DY8RjiIBmU5/', type: 'reel' },
    { url: 'https://www.instagram.com/p/DaYvT1gJOhO/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DagmM3Jtro9/', type: 'reel' },
    { url: 'https://www.instagram.com/reel/DZYkcfmN4IN/', type: 'reel' },
    { url: 'https://www.instagram.com/stories/highlights/17951470040837014/', type: 'story' }
  ],

  artPosts: [
    'https://www.instagram.com/p/Cg5E9yPFSfN/?img_index=1',
    'https://www.instagram.com/p/Civn0V1NqNR/',
    'https://www.instagram.com/p/CbBXx2XAa0_/?img_index=2',
    'https://www.instagram.com/p/C-Yhd8DMhUQ/',
    'https://www.instagram.com/p/C95n7KlhzEr/',
    'https://www.instagram.com/p/C-01i5fpHM8/',
    'https://www.instagram.com/p/DDdLG5sRY9h/?img_index=1',
    'https://www.instagram.com/p/DDuHnrxMVwU/',
    'https://www.instagram.com/p/DEGQh6ePd8x/',
    'https://www.instagram.com/p/DDdFMM5qgc8/',
    'https://www.instagram.com/p/DC1rjyQCoXc/?img_index=',
    'https://www.instagram.com/p/DAoEJ3vJyKe/?img_index=4',
    'https://www.instagram.com/arakenpetcenter/p/DRNnM5REvnZ/',
    'https://www.instagram.com/arakenpetcenter/p/DP1OXrmjsxz/',
    'https://www.instagram.com/royalpetshoploja/p/DSp6mjskeae/',
    'https://www.instagram.com/royalpetshoploja/p/DSXtpECEYZJ/',
    'https://www.instagram.com/samfigueiredoeventos/p/DQNM_EEkaca/',
    'https://www.instagram.com/samfigueiredoeventos/p/DTwRoXLkayH/',
    'https://www.instagram.com/arakenpetcenter/p/DWP1UmDDj0P/',
    'https://www.instagram.com/arakenpetcenter/p/DUJcSQcEh3Z/',
    'https://www.instagram.com/arakenpetcenter/p/DN8XSH_jrdB/',
    'https://www.instagram.com/p/DRAUH4BkZm9/'
  ]
};

export default mockData;
